import classNames from 'classnames';

import { BenefitData } from '../BenefitsExplorer';

const Tile = ({
    benefit,
    isSelected,
    setSelected,
}: {
    benefit: BenefitData;
    isSelected: boolean;
    setSelected: (benefit: BenefitData) => void;
}) => {
    return (
        <button
            className={classNames(
                'shadow-md rounded-benefits p-2 font-bold',
                'w-64',
                'benefits:h-44 benefits:w-44',
                'flex gap-x-2',
                'items-center',
                'benefits:flex benefits:flex-col benefits:justify-center',
                'border-2 benefits:border-4',
                isSelected ? 'bg-icon-primary border-primary' : 'bg-white border-transparent'
            )}
            onClick={() => setSelected(benefit)}
        >
            <span className="w-8 h-8 benefits:w-auto benefits:h-auto flex items-center justify-center">
                {isSelected ? benefit.icons[1] : benefit.icons[0]}
            </span>
            {benefit.name}
        </button>
    );
};

export default Tile;
